(function($) {
    //$(document).ready(function(){
        $( '.header-cta .hamburger' ).click(function(){
            $(this).toggleClass('is-active');
        });

        var btn = $('#totopbutton');

        $(window).scroll(function() {
            if ($(window).scrollTop() > 300) {
              btn.addClass('show');
            } else {
              btn.removeClass('show');
            }
          });
          btn.on('click', function(e) {
            e.preventDefault();
            $('html, body').animate({scrollTop:0}, '300');
          });
          if($('.images-wrapper').length){
                //$('.image-wrapper').each(function() { // the containers for all your galleries
                    $('.images-wrapper').magnificPopup({
                        delegate: 'a', // the selector for gallery item
                        type: 'image',
                        gallery: {
                        enabled:true
                        }
                    });
                    $('.feature-image').magnificPopup({
                        delegate: 'img' , type: 'image', 
                        gallery:{enabled:true},
                        callbacks: {
                         elementParse: function(item) { item.src = item.el.attr('src'); }
                    }
                   });
                //});
            }
        if($('.phone-icon').length){
            $('.phone-icon').on('click',function(e){
                window.location.href = "tel:"+$(this).data('tel');
            });
        }
})(jQuery);

var TestimonialSwiper = new Swiper('.testimonials-list', {
    // Optional parameters
    slidesPerView: 3,
    slidesPerGroup: 1,
    spaceBetween: 50,
    loop: true,
    // Navigation arrows
    navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        320: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        },
        375: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        },
        425: {
            slidesPerView: 1,
            slidesPerGroup: 1,
        },
        1112: {
            slidesPerView: 3,
            spaceBetween: 50,
            slidesPerGroup: 1,
        },
        1180: {
            slidesPerView: 3,
            spaceBetween: 50,
            slidesPerGroup: 1,
        },
        771: {
            slidesPerView: 1,
            slidesPerGroup: 1,
        }
    }
});

var a = 0;
if(jQuery('.hstats').length){
    jQuery(window).scroll(function() {
    var oTop = jQuery('.hstats').offset().top - window.innerHeight;
    if (a == 0 && jQuery(window).scrollTop() > oTop) {
        jQuery('.stat').each(function() {
            var $this = jQuery(this).find('.value'),
                countTo = $this.attr('data-count'),
                $parent = jQuery(this);
            jQuery({ countNum: $this.text()}).animate({
            countNum: countTo
            },
        
            {
        
            duration: 8000,
            easing:'linear',
            step: function() {
                if($parent.hasClass('stat3') || $parent.hasClass('stat4')){
                    $this.text(Math.floor(this.countNum)+'+');
                }else{
                    $this.text(Math.floor(this.countNum));  
                }
            },
            complete: function() {
                if($parent.hasClass('stat3') || $parent.hasClass('stat4')){
                    $this.text(this.countNum + '+');
                }else{
                    $this.text(this.countNum);
                }
            }
        
            });  
        
        });
        a = 1;
    }

    });
}

  
